import { EuiButtonIcon } from "@inscopix/ideas-eui";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

export const QuickActionToggleNotes = () => {
  const flyoutRightContent = useDataTableContext((s) => s.flyoutRightContent);
  const setFlyoutRightContent = useDataTableContext(
    (s) => s.setFlyoutRightContent,
  );

  const showingtableNotes = flyoutRightContent === "tableNotes";

  return (
    <EuiButtonIcon
      size="xs"
      display={showingtableNotes ? "base" : "empty"}
      iconType="documentEdit"
      aria-label="Toggle notes"
      onClick={() =>
        setFlyoutRightContent(!showingtableNotes ? "tableNotes" : undefined)
      }
      id={"quickActionToggleNotes"}
    />
  );
};
